export const CAPTCHA_TOKEN = '6LfuXjkgAAAAAF8ZvoF74cvE_umZTWPg7udhjMWk';
